import { Component } from 'react';
import axios from 'axios';
import { Breadcrumb, Heading } from '../../common/atoms';
import OverAllSection from './OverAllSection';
import { Tabbar } from '../../tailwind/molecules';
import { utilizationApi } from '../../../services';
import { handleAppError, setLocalStorage } from '../../handlers';
import { HealthCheckLocked, HealthChecksLow, dentalIcon, notEnabledDental, notEnabledVision, visionIcon } from '../../../assets/images';
import { MetricManager } from '../../../managers/HealthChecksManager';
import { RatingsManager, UtilizationGraphManager, ContractsManager, WalletUtilizationManager } from '../../../managers';
import { UtilizationLockScreen, LowUtilizationCard, NoUtilizationCard } from '../../common/organisms';
import {
  FILTER, TOTAL, TOTAL_AHC, TOTAL_DENTAL, TOTAL_VISION, TOTAL_COVID_VACCINATION, TOTAL_FLU_VACCINATION, TOTAL_SPECIALIST_CONSULTATION, TOTAL_OCCUPATIONAL_MEDICAL_ROOMS,
  TOTAL_CANCER_SCREENING, TOTAL_FERTILITY_TREATMENT, TOTAL_INCLINIC_CONSULTATION, AHC_LOCK_CONTENT, DENTAL_LOCK_CONTENT, VISION_LOCK_CONTENT,
  COVID_VACCINATION_LOCK_CONTENT, FLU_VACCINATION_LOCK_CONTENT, SPECIALIST_CONSULTATION_LOCK_CONTENT, OCCUPATIONAL_MEDICAL_ROOMS_LOCK_CONTENT,
  CANCER_SCREENING_LOCK_CONTENT, FERTILITY_TREATMENT_LOCK_CONTENT, INCLINIC_CONSULTATION_LOCK_CONTENT, BENEFIT_LOCK_CONTENT,
  TOTAL_PRE_EMPLOYMENT, PRE_EMPLOYMENT_LOCK_CONTENT
} from '../../../constants/utilization';
import { Benefit } from '../../common/templates/Utilization';
import moment from 'moment';
import DateRangePicker from '../../tailwind/molecules/DateRangePicker';
import { SALES_ROLE } from '../../../constants/overview';
import { Redirect, useLocation } from 'react-router-dom';
import { dsButtonGhostBrand, dsButtonPrimary, joinButtonClasses } from '../../../utils/buttonStyles';
let token = '';

class DynamicBenefitPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      metricObj: {},
      ratingObj: {},
      utilizationObj: {},
      costSavingObj: {},
      loading: true,
      walletUtilizationObj: {},
      benefitType: this.props.match.params.benefitType,
      benefitTypeNotFound: null,
      benefitName: null,
      enableBenefit: null,
      showNoUtilization: false,
      showNoWalletUtilization: false,
      benefit_id: null,
      filterDates: { startDate: null, endDate: null }
    };
  }

  benefitDetail = {
    ahc: {
      total: TOTAL_AHC,
      lockContent: AHC_LOCK_CONTENT, notEnabledBenefit: HealthCheckLocked, notUtilizedBenefit: HealthChecksLow
    },
    dental: {
      total: TOTAL_DENTAL,
      lockContent: DENTAL_LOCK_CONTENT, notEnabledBenefit: notEnabledDental, notUtilizedBenefit: dentalIcon
    },
    vision: {
      total: TOTAL_VISION,
      lockContent: VISION_LOCK_CONTENT, notEnabledBenefit: notEnabledVision, notUtilizedBenefit: visionIcon
    },
    covid_vaccination: {
      total: TOTAL_COVID_VACCINATION,
      lockContent: COVID_VACCINATION_LOCK_CONTENT
    },
    flu_vaccination: {
      total: TOTAL_FLU_VACCINATION,
      lockContent: FLU_VACCINATION_LOCK_CONTENT
    },
    specialist_consultation: { total: TOTAL_SPECIALIST_CONSULTATION, lockContent: SPECIALIST_CONSULTATION_LOCK_CONTENT },
    occupational_medical_rooms: { total: TOTAL_OCCUPATIONAL_MEDICAL_ROOMS, lockContent: OCCUPATIONAL_MEDICAL_ROOMS_LOCK_CONTENT },
    cancer_screening: { total: TOTAL_CANCER_SCREENING, lockContent: CANCER_SCREENING_LOCK_CONTENT },
    fertility_treatment: { total: TOTAL_FERTILITY_TREATMENT, lockContent: FERTILITY_TREATMENT_LOCK_CONTENT },
    inclinic_consultation: { total: TOTAL_INCLINIC_CONSULTATION, lockContent: INCLINIC_CONSULTATION_LOCK_CONTENT },
    pre_employment: { total: TOTAL_PRE_EMPLOYMENT, lockContent: PRE_EMPLOYMENT_LOCK_CONTENT }
  }


  fetchCompleteData = async (contractId, startDate, endDate) => {
    token = axios.CancelToken.source();
    this.setState({ loading: true })
    let start_date = startDate ? startDate : this.state.selectedContractObj.start_date
    let end_date = endDate ? endDate : this.state.selectedContractObj.end_date
    start_date = moment(start_date).format('YYYY-MM-DD')
    end_date = moment(end_date).format('YYYY-MM-DD')
    var fetchMertrics = utilizationApi.commonFetchMetrics({ contractId, benefit_type: this.state.benefitType, startDate: start_date, endDate: end_date, cancelToken: token.token });
    var fetchRatings = utilizationApi.commonFetchRatingsAndOptions({ contractId, benefit_type: this.state.benefitType, startDate: start_date, endDate: end_date, cancelToken: token.token });

    var fetchGraph = utilizationApi.commonFetchUtilizationGraph({
      contractId,
      benefit_type: this.state.benefitType,
      filter: 'department',
      startDate: start_date,
      endDate: end_date,
      cancelToken: token.token,
    });

    // var fetchWalletUtilization = utilizationApi.walletBenefitUtilization({ contractId, benefit_type : this.state.benefitType, startDate: start_date, endDate: end_date })

    try {
      let needBenefitData = await fetchMertrics
      this.setState({ benefit_id: needBenefitData.data.benefit_id, benefitName: needBenefitData.data.benefit_name, enableBenefit: needBenefitData.data.enable_benefit })
      var fetchCostSaving = utilizationApi.commonFetchCostSavingDetails({ contractId, benefit_type: this.state.benefitType, startDate: start_date, endDate: end_date, cancelToken: token.token });
    } catch (error) {
      if (axios.isCancel(error)) return;
      console.error('Error fetching metrics:', error);
      if (error.response && error.response.status === 400) {
        // Handle 400 error indicating benefit type not found
        this.setState({ benefitTypeNotFound: true, loading: false });
      } else {
        // Handle other errors
        console.log(error, 'Error');
        handleAppError(error);
      }
    }

    Promise.all([fetchMertrics, fetchRatings, fetchGraph, fetchCostSaving])
      .then((values) => {
        var resp_arr = values.map((resp) => resp.data);
        var metricObj = new MetricManager(resp_arr[0]);
        setLocalStorage((this.benefitDetail[this.state.benefitType]?.total || TOTAL), metricObj.totalHealthChecksCompleted);
        var ratingObj = new RatingsManager(resp_arr[1]);
        var utilizationObj = new UtilizationGraphManager(resp_arr[2], 'department')
        utilizationObj.xAxesLabel = 'Departments';
        var costSavingObj = resp_arr[3];
        var showNoWalletUtilization = metricObj.totalAmountSpent < 1;
        var showNoUtilization = metricObj.totalHealthChecksCompleted < 1;
        this.setState({ metricObj, ratingObj, utilizationObj, costSavingObj, loading: false, showNoUtilization, showNoWalletUtilization });
      })
      .catch((error) => {
        if (axios.isCancel(error)) return;
        if (error.response && error.response.status === 400) {
          // Handle 400 error indicating benefit type not found
          this.setState({ benefitTypeNotFound: true, loading: false });
        } else {
          // Handle other errors
          handleAppError(error);
        }
      });
  };

  fetchContractDetails = () => {
    const contractId = parseInt(this.props.location.state?.contractId, 10)

    utilizationApi.fetchContracts(
      {},
      (resp) => {
        const contractObj = new ContractsManager(resp.data, this.state.benefitType);
        const formattedData = contractObj.formattedData
        const selectedContractObj = formattedData.find(e => e.contract_id === contractId) ?? formattedData[0]
        this.setState({
          contracts: formattedData,
          selectedContractObj: selectedContractObj,
          contractId: selectedContractObj.contract_id,
          overallId: formattedData[0].contract_id,
          filterDates: { startDate: selectedContractObj?.start_date, endDate: selectedContractObj?.end_date }
        });
      },
      (err) => {
        handleAppError(err);
      }
    );
  };

  componentDidMount() {
    this.fetchContractDetails();
  }

  componentWillUnmount() {
    token && token.cancel();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.match.params.benefitType !== this.props.match.params.benefitType) {
      const newBenefitType = this.props.match.params.benefitType;
      this.setState({ benefitType: newBenefitType }, () => {
        // Fetch data with the updated benefitType
        this.fetchCompleteData(this.state.contractId, this.state.filterDates.startDate, this.state.filterDates.endDate);
      });
    }
    if ((this.state.contractId && prevState.contractId !== this.state.contractId) || (this.state.filterDates.startDate && prevState.filterDates.startDate !== this.state.filterDates.startDate) || (this.state.filterDates.endDate && prevState.filterDates.endDate !== this.state.filterDates.endDate)) {
      token && token.cancel();
      this.fetchCompleteData(this.state.contractId, this.state.filterDates.startDate, this.state.filterDates.endDate);
    }
  }

  getUtilizationBarData = ({ filter, xAxesLabel }) => {
    const contractId = this.state.contractId;
    let { startDate, endDate } = this.state.filterDates
    let start_date = startDate ? startDate : this.state.selectedContractObj.start_date
    let end_date = endDate ? endDate : this.state.selectedContractObj.end_date
    start_date = moment(start_date).format('YYYY-MM-DD')
    end_date = moment(end_date).format('YYYY-MM-DD')
    let utilizationObj = { barlabels: [], bardata: [], barBgColors: [], xAxesLabel: xAxesLabel };
    utilizationApi.commonFetchUtilizationGraph(
      { filter: filter, contractId, benefit_type: this.state.benefitType, startDate: start_date, endDate: end_date },
      (resp) => {
        utilizationObj = new UtilizationGraphManager(resp.data, filter);
        utilizationObj.xAxesLabel = xAxesLabel;
        this.setState({ utilizationObj });
      },
      (err) => {
        this.setState({ utilizationObj });
        handleAppError(err);
      }
    );
  };

  toggleHelp = () => this.props.toggleHelp(this.state.benefitName?.replace(/\s+/g, '_'));

  content = (selectedContractObj) => {
    const { showNoUtilization, showNoWalletUtilization, loading, overallId } = this.state;

    if (loading || this.state.enableBenefit) {
      return (showNoUtilization && showNoWalletUtilization) ? (
        <NoUtilizationCard
          line={`utilization of ${this.state.benefitName?.toLowerCase()} by employees and their dependents`}
          imgsrc={this.benefitDetail[this.state.benefitType]?.notUtilizedBenefit || HealthChecksLow}
          toggleHelp={this.toggleHelp}
          classes='mt-8'
        />
      ) : (
        <Benefit {...this.state} sqaureTabHandler={(type) => this.getUtilizationBarData(FILTER[type])} />
      );
    } else if (selectedContractObj.is_overall_contract) {
      token && token.cancel();
      token = axios.CancelToken.source();
      return <OverAllSection contractId={overallId} token={token} benefitType={this.state.benefitType} benefitName={this.state.benefitName?.toLowerCase()} />;
    } else {
      return (
        <div className='mt-8'>
          <UtilizationLockScreen
            sectionTitle={`${this.state.benefitName?.toLowerCase()} are not enabled`}
            image={this.benefitDetail[this.state.benefitType]?.notEnabledBenefit || HealthCheckLocked}
            sectionSubtitle='Benefits to your employees'
            points={this.benefitDetail[this.state.benefitType]?.lockContent || BENEFIT_LOCK_CONTENT}
            toggleHelp={this.toggleHelp}
          />
        </div>
      );
    }
  };

  changeContractId = (contractId) => {
    contractId = parseInt(contractId, 10)
    const { contracts = [], selectedContractObj } = this.state
    const newContract = contracts.find(e => e.contract_id === contractId)
    const { contract_id: oldContractId } = selectedContractObj

    if (contractId && oldContractId !== contractId) {
      this.setState({
        contractId: contractId,
        selectedContractObj: newContract,
        metricObj: {},
        walletUtilizationObj: {},
        ratingObj: {},
        costSavingObj: {},
        utilizationObj: {},
        loading: true,
        showNoUtilization: false,
        showNoWalletUtilization: false,
        filterDates: { startDate: newContract.start_date, endDate: newContract.end_date }
      });
    } else {
      this.setState({
        contractId: contractId,
        selectedContractObj: contracts.find(e => e.is_overall_contract),
        loading: false,
        showNoUtilization: false,
        showNoWalletUtilization: false,
        filterDates: { startDate: newContract?.start_date, endDate: newContract?.end_date }
      });
    }
  };

  changeDates = (e, date_type) => {
    let date = moment(e).format('YYYY-MM-DD')
    if (e) {
      if (date_type === 'startDate') {
        this.setState({ filterDates: { ...this.state.filterDates, startDate: date } })
      }
      else if (date_type === 'endDate') {
        this.setState({ filterDates: { ...this.state.filterDates, endDate: date } })
      }
      else if (date_type === 'reset') {
        this.setState({ filterDates: { startDate: moment(this.state.selectedContractObj?.start_date) }, endDate: moment(this.state.selectedContractObj?.end_date) })
      }
    }
    else {
      if (date_type === 'startDate') {
        this.setState({ filterDates: { ...this.state.filterDates, startDate: moment(this.state.selectedContractObj.start_date).format('YYYY-MM-DD') } })
      }
      else {
        this.setState({ filterDates: { ...this.state.filterDates, endDate: moment(this.state.selectedContractObj.end_date).format('YYYY-MM-DD') } })
      }
    }
  };

  navigateToActivityLog = () => {
    const { start_date, end_date, contract_id } = this.state.selectedContractObj
    this.props.history.push(`/activity-log?point=${this.state.benefitType}&benefit_name=${this.state.benefitName}`, { start_date, end_date, contract_id });
  };

  navigateToView = () => {
    const { start_date, end_date, contract_id } = this.state.selectedContractObj
    let targetURL;

    switch (this.state.benefitType) {
      case 'ahc':
        targetURL = '/health-checks/network';
        break;
      case 'dental':
        targetURL = '/dental-checks/network';
        break;
      case 'vision':
        targetURL = '/vision-checks/network';
        break;
    }

    this.props.history.push(targetURL, { benefit_id: this.state.benefit_id, type: `${this.state.benefitName}`, link: `/utilization/${this.state.benefitType}`, start_date: start_date, end_date: end_date, contract_id: contract_id });
    localStorage.setItem('benefit_id', this.state.benefit_id);
  };


  render() {
    const { contracts = [], selectedContractObj } = this.state;
    const tabbarList = contracts.map(e => e.text)
    const tabbarIds = contracts.map(e => e.contract_id ?? 'overall-id')

    if (this.state.benefitTypeNotFound) {
      // Render the forbidden page component
      return <Redirect to='/forbidden' />
    }
    return (
      <div className='min-w-0'>
        <div className='flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between'>
          <div className='min-w-0'>
            <Breadcrumb
              list={[
                { text: 'Utilization', link: '/utilization/ahc' },
                { text: `${this.state.benefitName}`, link: `/utilization/${this.state.benefitType}` },
              ]}
              classes='mb-1'
            />
            {typeof this.state.selectedContractObj !== 'undefined' && (
              <Heading
                mainHeading={`Utilization of ${this.state.benefitName}`}
                mainClasses='font-fig-extrabold text-3xl font-medium leading-tight tracking-tight text-gray-900 sm:text-4xl'
              />
            )}
          </div>
          <div className='flex shrink-0 flex-wrap gap-2 lg:justify-end'>
            {['ahc', 'dental', 'vision'].includes(this.state.benefitType) && (
              <button
                type='button'
                onClick={this.navigateToView}
                className={joinButtonClasses(dsButtonGhostBrand, 'h-10 px-8', SALES_ROLE === 'sales' && 'cursor-not-allowed')}
                disabled={this.state.loading || SALES_ROLE === 'sales'}
              >
                Provider details
              </button>
            )}
            <button
              type='button'
              onClick={this.navigateToActivityLog}
              disabled={this.state.loading || SALES_ROLE === 'sales'}
              className={joinButtonClasses(dsButtonPrimary, 'h-10 px-5', SALES_ROLE === 'sales' && 'cursor-not-allowed')}
            >
              Activity Log
            </button>
          </div>
        </div>
        <div className='mt-6 flex justify-start'>
          <div className='text-xs font-semibold uppercase tracking-wider text-gray-500'>Contract period / year</div>
        </div>
        <div className='mt-3'>
          <Tabbar
            list={tabbarList}
            ids={tabbarIds}
            loading={!selectedContractObj}
            newPageId={selectedContractObj ? (selectedContractObj.contract_id ?? 'overall-id') : ''}
            changeHandler={this.changeContractId}
          />
        </div>
        {selectedContractObj && (
          <div className='mt-3'>
            <DateRangePicker
              isCurrent={selectedContractObj?.is_running_contract}
              isOverAll={selectedContractObj?.is_overall_contract}
              filterDates={this.state.filterDates}
              contractDates={[this.state.selectedContractObj?.start_date, this.state.selectedContractObj?.end_date]}
              changeDates={this.changeDates}
            />
          </div>
        )}
        {this.content(this.state.selectedContractObj)}
      </div>
    );
  }
}

export default DynamicBenefitPage;
